import { format, parseISO } from 'date-fns';

const EM_DASH = '—';

/**
 * Format a timestamp as "May 15, 2026 10:23 AM" (local time).
 * Returns an em-dash for null/invalid input.
 */
export const formatDateTime = (value) => {
  if (!value) return EM_DASH;
  try {
    const d = typeof value === 'string' ? parseISO(value) : value;
    return format(d, 'MMM d, yyyy h:mm a');
  } catch {
    return EM_DASH;
  }
};

/**
 * Format a date-only value as "May 28, 2026". Uses the YYYY-MM-DD calendar
 * prefix so a timezone offset can never shift the displayed day.
 */
export const formatDate = (value) => {
  if (!value) return EM_DASH;
  const s = typeof value === 'string' ? value : value.toISOString?.() || '';
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return format(d, 'MMM d, yyyy');
  }
  try {
    return format(parseISO(s), 'MMM d, yyyy');
  } catch {
    return EM_DASH;
  }
};

/** Hours to one decimal place (e.g. 144.0). Em-dash for null. */
export const formatHrs1 = (value) =>
  value == null ? EM_DASH : Number(value).toFixed(1);

/**
 * Timecard-style hours: em-dash for null OR zero; whole numbers without a
 * decimal, fractional with one decimal (e.g. 8, 8.5).
 */
export const formatHoursOrDash = (value) => {
  if (value == null || Number(value) === 0) return EM_DASH;
  const n = Number(value);
  return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
};

/** Percent value with a trailing % (e.g. "60%"). Em-dash for null. */
export const formatPct = (value) => {
  if (value == null) return EM_DASH;
  const n = Number(value);
  return `${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}%`;
};

/** Truncate long text with an ellipsis. */
export const truncate = (text, max = 30) =>
  text && text.length > max ? `${text.slice(0, max)}…` : text;

export { EM_DASH };
